import { Type } from '@angular/core';

/*
 	When a date type is DTY_CUSTOM, it's necessary to determine which component to use based on the column name.
	This map depends on the application, as each app may require different behaviors.
*/
const COMPONENT_MAP: { [key: string]: Type<any> } = {
};

export function getComponentByName(name: string): Type<any> | undefined {
	return COMPONENT_MAP[name];
}